export default {
  /**
   * 金额千分符
   * @param {number, string} amount 金额
   * @param {string} key key仅用来表示字段
   * @param {number} decimal 保留小数位
   * @param {string} type 小数位处理方式
   */
  // 多参数调用
  thousandMark (amount, key, decimal = 2, type = 'round') {
    const str = thousandMark(amount, key, decimal, type)
    return str
  },
  // 表格formatter直接使用，只能使用两位小数
  simpleTM (row, column, val) {
    if (isNaN(val)) {
      return val
    }
    const str = thousandMark(val)
    return str
  },
  // 表格formatter直接使用，只能使用两位小数
  simpleInt (row, column, val) {
    if (isNaN(val)) {
      return val
    }
    const str = thousandMark(val, '', 0)
    return str
  }
}

function thousandMark (amount, key, decimal = 2, type = 'round') {
  // 数值 0 需要进行补充小数，不直接返回
  if (isNaN(amount) || amount === undefined || amount === '' || amount === null) {
    return amount
  }
  const num = type === 'round' ? Math.round(parseFloat(Number(amount)) * Math.pow(10, decimal)) / Math.pow(10, decimal) // 四舍五入
    : Math.floor(parseFloat(Number(amount)) * Math.pow(10, decimal)) / Math.pow(10, decimal) // 向下舍去
  const nag = num < 0 // 正负号判断
  const strArr = Math.abs(num).toString().split('.') // 拆分整数小数
  const intStr = strArr[0] // 整数
  const floatStr = strArr.length === 2 ? strArr[1] : '' // 小数
  const reg = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g // 整数千分符
  return (nag ? '-' : '') + intStr.replace(reg, '$1,') + (decimal === 0 ? '' : ('.' + getFloatString(floatStr, decimal)))
}
// 生成小数位
function getFloatString (num, decimal) {
  let len = num.toString().length
  while (len < decimal) {
    num = num + '0'
    len++
  }
  return num
}
